/**
 *
 * @constructor
 */
function TaskPage() {
    /**
     *
     */
    TaskPage.prototype.initialize = function (console, mesh, task) {
        this.id = "task";
        this.console = console;
        this.mesh = mesh;
        this.task = task;
        this.showBottomBar = true;

        return this;
    };

    /**
     *
     */
    TaskPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.mode = 'error';
        this.console.Ui.turnOn("errorLogLevel");

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    TaskPage.prototype.leave = function () {
    };
}
